export default __webpack_public_path__ + "static/media/tzgg.c58d6587.jpg";